module.exports = __webpack_public_path__ + "img/REGISTRO 1.06fee28b.png";